import { toast } from 'react-toastify';
import { tokenManager } from '../services/axiosInstance';
import forge from "node-forge";
import { de } from 'date-fns/locale';

export const downloadFile = ({ data, fileName, fileType }) => {
  const blob = new Blob([data], { type: fileType });
  const a = document.createElement('a');
  a.download = fileName;
  a.href = window.URL.createObjectURL(blob);
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  a.dispatchEvent(clickEvt);
  a.remove();
};

export const designFeaturesColor = {
  color1: '#E4E9FA',
  color2: '#C6D2F6',
  color3: '#A2B8F1',
  color4: '#749AED',
  color5: '#1A73E8',
};

export const overAllRatingColor = {
  color1: '#E4EFE8',
  color2: '#A3CDB4',
  color3: '#C6DFD0',
  color4: '#76BA93',
  color5: '#26A568',
};

export const infoIcon = (
  <svg
    width='21'
    height='18'
    viewBox='0 0 21 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    class='rotating-svg'>
    <path
      fillRule='evenodd'
      clip-rule='evenodd'
      d='M10.6493 15.4544C13.5928 15.4544 15.8184 13.1778 16.2933 9.77899L14.0137 10.9145C13.6062 11.1175 13.114 10.9462 12.9142 10.5319C12.7145 10.1177 12.883 9.61732 13.2905 9.41432L16.8476 7.6425C17.182 7.47593 17.5848 7.55877 17.8292 7.8444L20.2983 10.7299C20.5961 11.078 20.56 11.6056 20.2175 11.9083C19.8751 12.2111 19.3561 12.1743 19.0582 11.8263L17.8516 10.4162C17.1597 14.2263 14.508 17.125 10.6493 17.125C8.48051 17.125 6.52631 16.1657 5.10687 14.6353C4.79554 14.2996 4.81085 13.771 5.14107 13.4545C5.47128 13.1381 5.99135 13.1536 6.30268 13.4893C7.44081 14.7164 8.97407 15.4544 10.6493 15.4544Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clip-rule='evenodd'
      d='M10.3507 2.54557C7.4072 2.54557 5.18161 4.82221 4.70674 8.22101L6.98625 7.08555C7.39378 6.88255 7.88605 7.0538 8.08576 7.46805C8.28546 7.8823 8.11699 8.38268 7.70946 8.58568L4.15243 10.3575C3.81801 10.5241 3.4152 10.4412 3.1708 10.1556L0.701728 7.27007C0.40389 6.922 0.440039 6.3944 0.782469 6.09165C1.1249 5.78891 1.64394 5.82565 1.94178 6.17373L3.14836 7.58382C3.84029 3.77372 6.49202 0.875 10.3507 0.875C12.5195 0.875 14.4737 1.83435 15.8931 3.36471C16.2045 3.70037 16.1891 4.22901 15.8589 4.54547C15.5287 4.86193 15.0086 4.84637 14.6973 4.51071C13.5592 3.28364 12.0259 2.54557 10.3507 2.54557Z'
      fill='white'
    />
  </svg>
);

export const successIcon = (
  <svg width='15' height='12' viewBox='0 0 15 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clip-rule='evenodd'
      d='M13.9773 0.421491C14.2968 0.685089 14.3421 1.15779 14.0785 1.47731L5.82853 11.4773C5.69297 11.6416 5.49393 11.7405 5.28109 11.7494C5.06826 11.7582 4.86171 11.6761 4.713 11.5236L0.963 7.67744C0.673838 7.38087 0.679848 6.90603 0.976425 6.61687C1.273 6.3277 1.74784 6.33371 2.037 6.63029L5.20344 9.87792L12.9215 0.522734C13.1851 0.20322 13.6578 0.157892 13.9773 0.421491Z'
      fill='white'
    />
  </svg>
);

export const showToast = (message, type = 'info') => {
  // Define a default configuration for the toast
  const toastConfig = {
    type,
    autoClose: false,
    closeOnClick: true,
    draggable: true,
  };

  // Customize color and icon based on toast type
  switch (type) {
    case 'success':
      toastConfig.icon = successIcon; // Success icon
      toastConfig.style = {
        backgroundColor: '#26A568',
        color: '#fff',
      };
      toastConfig.autoClose = true;
      break;
    case 'error':
      toastConfig.icon = '❌'; // Error icon
      toastConfig.style = {
        backgroundColor: '#e74c3c',
        color: '#fff',
      };
      toastConfig.autoClose = true;
      break;
    case 'warning':
      toastConfig.icon = '⚠️'; // Warning icon
      toastConfig.style = {
        backgroundColor: '#f39c12',
        color: '#fff',
      };
      toastConfig.autoClose = true;
      break;
    case 'info':
    default:
      toastConfig.icon = infoIcon; // Info icon
      toastConfig.style = {
        backgroundColor: '#B2B2DB',
        color: '#fff',
      };
      toastConfig.iconStyle = {
        transform: 'rotate(-90deg)', // Rotate icon 90 degrees anti-clockwise
        transition: 'transform 0.3s ease-in-out', // Optional: Smooth rotation animation
      };
      break;
  }

  // Dismiss all the active toast messages
  toast.dismiss();

  // Show the toast with the customized configuration
  toast(message, toastConfig);
};

export const downloadImage = async (image, fileName = 'TypeInContext_AI') => {
  const imageUrl = image?.images?.includes('dump')
    ? `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${image?.images}`
    : `${process.env.REACT_APP_AWS_BUCKET_URL}/${image.modelName}/specific_need/${image.md5hash}/${image.images}`;

  try {
    const token = tokenManager.getToken();
    const response = await fetch(
      `${process.env.REACT_APP_TYPETESTER_BACKEND_URL}/download-image?imageUrl=${imageUrl}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error('Error downloading image');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return response;
  } catch (error) {
    console.error('Error:', error);
  }
};

export const formatTimeStamp = (timestamp) => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const formattedTime = `${day}/${month}/${year} at ${hours}:${minutes} ${ampm}`;
  return formattedTime;
};

export const pushAdobeDataLayerEvent = (eventData) => {
  if (window && window.adobeDataLayer) {
    window.adobeDataLayer.push(eventData);
    console.log('Adobe Data Layer Event Pushed:', eventData);
  } else {
    console.warn('Adobe Data Layer is not initialized');
  }
};

export const getPageNameFromLocation = (pathName, isCreatePageVisible) => {
  switch (pathName) {
    case '/generate-image':
      return isCreatePageVisible ? 'generation page' : 'create page';
    case '/your-past-creations':
      return 'past creation';
    case '/user-history':
      return 'user history';
    case '/analytics':
      return 'analytics';
  }
};

export const generate16digitSessionId = () => {
  return Math.floor(1000000000000000 + Math.random() * 9000000000000000).toString();
};

export const getSessionId = () => {
  let sessionId = sessionStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = generate16digitSessionId();
    sessionStorage.setItem('sessionId', sessionId);
  }
  return sessionId;
};

export function encodeToBase64(input) {
  if (typeof input !== 'string') {
    throw new Error('Input must be a string');
  }
  return btoa(input);
}

export const reandomFontPicker = (recommendedFontList, generatedImages) => {
  // Extract all font_ids from generatedImages
  const generatedFontIds = new Set(generatedImages.map((image) => image.md5hash));

  // Filter recommendedFontList to exclude items with md5 matching any font_id
  const filteredFonts = recommendedFontList
    .map((font, index) => ({ ...font, index })) // Include index for reference
    .filter((font) => !generatedFontIds.has(font.md5));

  // If no valid fonts are available, return the first available font or handle the case
  if (filteredFonts.length === 0) {
    return recommendedFontList.length > 0 ? recommendedFontList[0] : -1;
  }

  // Pick a random index from the filtered list
  const randomIndex = Math.floor(Math.random() * filteredFonts.length);

  // Return the original index of the randomly selected font
  return filteredFonts[randomIndex];
};
const fetchPrivateKey = async () => {
  try {
    const token = tokenManager.getToken();
    const response = await fetch(`${process.env.REACT_APP_TYPETESTER_BACKEND_URL}/get-private-key`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (!data.privateKey) {
      throw new Error('Private key not found in response');
    }
    return data.privateKey;
  } catch (error) {
    console.error('Error fetching private key:', error);
    return null;
  }
};

export const decryptArray = async (encryptedData) => {
  try {
    const privateKeyPem = await fetchPrivateKey();
    const privateKey = forge.pki.privateKeyFromPem(privateKeyPem);

    const decodedData = decodeURIComponent(encryptedData);
    const encryptedBytes = forge.util.decode64(decodedData);

    const decrypted = privateKey.decrypt(encryptedBytes, "RSA-OAEP", {
      md: forge.md.sha256.create()
    });
    return JSON.parse(decrypted);
  } catch (error) {
    console.error('Error decrypting data:', error);
    return null;
  }
};
